export default {
    login: {
        username: {
            title: "Login ID",
            placeholder: "Enter your Login ID"
        },
        otp: {
            title: "Security Code",
            placeholder: "Enter your Security Code"
        },
        validation: {
            fieldRequired: "Field %{fieldName} is required",
        },
        error: "Login failed"
    },
    button: {
        submit: "Submit",
        revoke: "Revoke",
        proceed: "Proceed",
        cancel: "Cancel",
        close: "Close",
        retry: "Retry"
    },
    table: {
        pagination: {
            next: "Next Page",
            previous: "Previous Page",
            last: "Last Page",
            first: "First Page"
        },
        hover: {
            deleteToken: "Delete current token",
            sortColumn: "Sort current column"
        },
        deletion: {
            success: "The token has been successfully deleted.",
            error: "An error occurred, please try again later."
        },
        noData: "There is no data to display."

    },
    payments: {
        title: "Payment details",
        fields: {
            debtorIban: "Debtor's IBAN",
            creditorName: "Creditor name",
            creditorIban: "Creditor's IBAN",
            creditorAgent: "Creditor agent",
            currency: "Currency",
            amount: "Amount"
        },
        instructions: {
            list: "In order to submit the current payment, you need to confirm your identity by using a hardware authenticator. Please follow the instructions below:",
            list1: "Turn on your hardware authenticator and type your pin, if necessary.",
            list2: "According to your device manual, select the option that provides a PIN-protected one time password (otp), also known as \"challenge-response functionality\".",
            list3: "Then you will be required to type a six digit PIN code (challenge).",
            list4: "Type the following sequence: <br/> <b>%{paymentCode}</b><br/>",
            list5: "Afterwards, you will be provided with your otp.",
            list6: "Type in the form below your Login ID and the aforementioned otp at the Security Code input. You may proceed with the payment's submission.",
            list7: "Bear in mind that the otp code usually lasts for only 2-3 minutes and you may use it only once within this timespan.",
            list8: "In case of any mistake (wrong username or password due to a mistyping) you should wait for 2 or 3 minutes in order to re-generate a new Security Code (otp) by repeating the above steps.",
        }
    },
    messagePage: {
        error: "An error occurred. Please try again.",
        unknownError: "Something went wrong.",
        success: "Payment submitted successfully for furthering processing",
        cancel: "You have cancelled the payment's submission.",
        info: "You have reached this page for unknown reasons."
    },
    copyright: "Copyright ©",
    logout: "Sign out"
}